import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { ProfileType } from '@/enum/profile-type'

export function LayoutCompletePreserver() {
  const { userProfiles } = useAuth()

  const isNotAdminOrSuperAdminOrSupervisor =
    !userProfiles?.includes(ProfileType.Admin) &&
    !userProfiles?.includes(ProfileType.SuperAdmin) &&
    !userProfiles?.includes(ProfileType.Supervisor)

  if (isNotAdminOrSuperAdminOrSupervisor) {
    return <Navigate to="/not-allowed" replace />
  }

  return <Outlet />
}
